export enum UserRoleEnum {
  Admin = "Admin",
  Employee = "Employee",
}

export enum ProfilePictureTypeEnum {
  Initials = "Initials",
  UploadImage = "UploadedImage",
}
